'use client';

import { useSelectedLayoutSegments } from 'next/navigation';
import { Box, GridLayout } from '@wishket/design-system';

import { CompanyInfo, ContactUs, LinkSet, ServiceSet, SnsSet } from './parts';

const BLUEGRAY_BACKGROUND_PAGES: string[] = ['slackbot', 'questions', 'signup'];

const Footer = () => {
  const segments = useSelectedLayoutSegments();

  const needBorderTop = segments.some((segment) =>
    BLUEGRAY_BACKGROUND_PAGES.includes(segment)
  );

  return (
    <Box className="w-full bg-w-gray-50 desktop:pb-[80px]" data-testid="footer">
      <GridLayout gridTemplateAreaClass="grid-areas-footer-mobile tablet:grid-areas-footer-tablet desktop:grid-areas-footer-desktop gap-y-10 desktop:gap-x-0">
        <ServiceSet needBorderTop={needBorderTop} />
        <SnsSet needBorderTop={needBorderTop} />
        <ContactUs />
        <LinkSet />
        <CompanyInfo />
      </GridLayout>
    </Box>
  );
};

export default Footer;
